import * as React from "react";
const SvgFiRrBanner = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-banner_svg__a)">
      <path
        fill="#062147"
        d="M23.562 9.572c.43-.492.555-1.181.323-1.799a1.7 1.7 0 0 0-1.353-1.099C20.22 6.355 15.325 6 12 6s-8.22.355-10.534.674A1.7 1.7 0 0 0 .113 7.773a1.78 1.78 0 0 0 .323 1.799c.052.059 3.208 2.309 3.208 2.309S.847 14.687.814 14.735a1.78 1.78 0 0 0-.064 1.943c.353.583.983.891 1.648.809 2.384-.303 6.601-.54 9.601-.54s7.217.237 9.601.54q.109.014.215.014c.584 0 1.12-.303 1.434-.822a1.79 1.79 0 0 0-.064-1.943c-.033-.048-2.83-2.854-2.83-2.854s3.156-2.25 3.208-2.309zm-5.33 1.362a.998.998 0 0 0-.13 1.523l2.951 2.954c-2.517-.266-6.293-.463-9.054-.463-2.76 0-6.537.197-9.054.463l2.951-2.954a1 1 0 0 0-.129-1.523L2.43 8.568C4.863 8.284 9.056 8 11.998 8s7.137.284 9.568.568l-3.337 2.366z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-banner_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBanner;
